import {capitalize} from "../filters"

const title = (store) => {
  return (to, from, next) => {
    document.title = capitalize(to.name || 'Gemstone')
    next()
  }

}


const initialState = (store) => {
  return (to, from, next) => {
    if (to.name !== "Login") {
      store.dispatch('initializeStore').then(ok => {
        if (ok) next()
        else next({name: 'Login'})
      })
    } else {
      next()
    }
  }
}

const lockAccountState = (store) => {
  return (to, from, next) => {
    if (store.getters['authentication/getAccountLock']) {
      if (to.name === "LockScreen") {
        next()
      } else {
        next({name: 'LockScreen'})
      }
    } else {
      next()
    }
  }
}

export const login = (store)=>{
  return (to, from, next) => {
    if (!store.getters['authentication/isAuthenticated']) {
      next()
    } else {
      next({name: 'Main Dashboard'})
    }
  }
}


// Admin-only guard using either permissions or user roles
const adminOnly = (store) => {
  return (to, from, next) => {
    if (!to.meta || !to.meta.requiresAdmin) {
      return next()
    }

    const isAuthenticated = store.getters['authentication/isAuthenticated']
    if (!isAuthenticated) {
      return next({ name: 'Login' })
    }

    const authUser = store.getters['authentication/getAuthUser']
    const userRoles = (authUser && authUser.menuroles)
      ? (Array.isArray(authUser.menuroles) ? authUser.menuroles : String(authUser.menuroles).split(','))
      : []

    const permissions = store.getters['authentication/getPermissions'] || []
    const hasAdminRole = userRoles.includes('admin')
    const hasElevatedPermission = permissions.includes('all_permissions') || permissions.includes('admin')

    if (hasAdminRole || hasElevatedPermission) {
      return next()
    }

    return next({ name: '404' })
  }
}


// export const permission = (to, from, next) => {
//     if (!to.meta.permission) {
//         next()
//     } else if ('show_hel' == to.meta.permission) next()
//     else {
//         next({ name: from.name })
//     }
// }

export default {
  title,
  initialState,
  lockAccountState,
  adminOnly,
  // permission
}
